export const obtenerValorEnvio = (cotizacion) => {

    let obj = cotizacion.flete + (cotizacion.extraInsurance ? cotizacion.extraInsurance : 0) + (cotizacion.minimumInsurance ? cotizacion.minimumInsurance : 0)

    return obj

}